export default "__VITE_ASSET__CPjOMK2b__"